import * as React from 'react';
import SuggestionOfferForm from "../../components/SuggestionOffers/SuggestionOfferForm/SuggestionOfferForm";
var SuggestionOffer = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u043E \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u043D\u0438\u0435"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(SuggestionOfferForm, null))))));
};
export default SuggestionOffer;



//////////////////
// WEBPACK FOOTER
// ./src/views/SuggestionOffers/SuggestionOffer.tsx
// module id = 480
// module chunks = 0